import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import UserToCaseAssignmentModel from "../../models/user-to-case-assignment";

export default class UserToCaseAssignmentRepository extends BaseRepository {
  static modelClass = UserToCaseAssignmentModel;
  modelName = "user-to-case-assignment";
}
